/**
 * Logger Utility
 * Production ortamında console.log'ları devre dışı bırakır
 * Development'ta tüm log seviyelerini gösterir
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * Geliştirme bilgileri için kullanılır
   * Production'da gösterilmez
   */
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Uyarı mesajları için kullanılır
   * Production'da gösterilmez
   */
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  /**
   * Hata mesajları için kullanılır
   * Production'da da gösterilir (error tracking için)
   */
  error: (...args: any[]) => {
    console.error(...args);
    // TODO: Production'da Sentry veya başka error tracking service'e gönder
    // if (!isDevelopment) {
    //   Sentry.captureException(args[0]);
    // }
  },

  /**
   * Debug bilgileri için kullanılır
   * Production'da gösterilmez
   */
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  /**
   * Bilgi mesajları için kullanılır
   * Production'da gösterilmez
   */
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
};

export default logger;
